import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, ZapIcon, TargetIcon, SparklesIcon, BarChart3Icon, CalendarIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: BrainIcon,
    title: 'Por qué tu cerebro se "congela" cuando más lo necesitas',
    description: '(Y por qué no tiene nada que ver con tu disciplina ni tus ganas)'
  }, {
    icon: ZapIcon,
    title: 'El Interruptor #1 — El Apagón del Caos',
    description: 'Cómo pasar del caos mental de la casa al enfoque de tu negocio en 60 segundos. El mismo principio que usas para calmar a tus hijos cuando lloran, aplicado a tu propio sistema de alertas.'
  }, {
    icon: TargetIcon,
    title: 'El Interruptor #2 — El Modo Dinero',
    description: 'Un truco visual que hace que tu cerebro ignore las distracciones del entorno y se enfoque solo en la tarea que genera ingresos. Sin fuerza de voluntad. Sin esfuerzo extra.'
  }, {
    icon: SparklesIcon,
    title: 'El Interruptor #3 — La Chispa de los 60 Segundos',
    description: 'Cómo eliminar el bajón de energía de la tarde sin café y sin pastillas para que puedas terminar tu jornada con la misma fuerza con la que la empezaste.'
  }, {
    icon: BarChart3Icon,
    title: 'Tu Mapa Personal de Energía',
    description: 'Descubre en qué horas del día tu cerebro está en su PICO máximo para hacer las tareas que generan dinero en esos momentos exactos (y dejar lo administrativo para cuando tu energía está baja).'
  }, {
    icon: CalendarIcon,
    title: 'Tu Plan de 7 Días',
    description: 'Un calendario de implementación día por día para que no intentes cambiar todo a la vez y realmente lo pongas en práctica.'
  }];
  return <section className="w-full bg-white px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-20">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-5 md:mb-12" data-id="element-21">
            Lo que vas a <span className="text-[#E8734A]" data-id="element-22">aprender</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-3 md:gap-6 text-left" data-id="element-23">
            {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 flex flex-col items-center text-center hover:shadow-md transition-shadow border border-[#F5E6DC]" data-id="element-24">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-[#E8734A] bg-opacity-10 rounded-full flex items-center justify-center mb-3 md:mb-6" data-id="element-25">
                    <Icon className="w-6 md:w-8 h-6 md:h-8 text-[#E8734A]" data-id="element-26" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#2D2D2D] mb-2 md:mb-4 leading-tight" data-id="element-27">
                    {benefit.title}
                  </h3>
                  <p className="text-[#2D2D2D] leading-relaxed" data-id="element-28">
                    {benefit.description}
                  </p>
                </motion.div>;
          })}
          </div>

          <div className="mt-5 md:mt-12 bg-[#2D2D2D] rounded-xl p-5 md:p-10 shadow-lg max-w-3xl mx-auto" data-id="element-29">
            <div className="flex justify-center mb-3 md:mb-4" data-id="element-30">
              <TargetIcon className="w-10 h-10 text-[#D4A853]" data-id="element-31" />
            </div>
            <p className="text-2xl font-bold text-white mb-3 md:mb-4" data-id="element-32">
              El Sistema de{' '}
              <span className="text-[#D4A853]" data-id="element-33">3 Bloques de 20 Minutos</span>
            </p>
            <p className="text-lg text-white opacity-90 leading-relaxed" data-id="element-34">
              Cómo organizar tu tiempo de negocio para vender{' '}
              <span className="font-bold text-[#E8734A]" data-id="element-35">
                sin estar pegada al teléfono 24/7
              </span>
              . El sistema que usan las mamás que parecen hacer magia con su
              tiempo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}